/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-400);
  padding: var(--padding);
  color: var(--color);
  flex-grow: 1;
  contain: initial;
}
